// extracted by mini-css-extract-plugin
module.exports = {"root":"navlink_root__6fQQb","body":"navlink_body__4TcR8"};